<template>
    <v-app>
        <v-container fluid>
            <v-row>
                <v-col cols="12" class="py-0">
                    <breadCrumbs></breadCrumbs>
                </v-col>
            </v-row>
            <v-row class="center">
                <v-col md="5" cols="12">
                    <v-expansion-panels v-model="panel">
                        <v-expansion-panel>
                            <v-expansion-panel-title class="panel-header">Change Password</v-expansion-panel-title>
                            <v-expansion-panel-text class="expansion-padding">
                                <v-form @submit.prevent="submit" ref="changePasswordForm" id="changePasswordForm">
                                    <v-row class="no-gutters" justify="center">

                                        <v-col cols="12"> 

                                            <v-text-field
                                                label="Current Password"
                                                density="compact"
                                                single-line
                                                :type="visible ? 'text' : 'password'"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="current_password.value.value"
                                                :error-messages="current_password.errorMessage.value"
                                                @click:append-inner="visible = !visible"
                                                :append-inner-icon="visible ? 'mdi-eye-off' : 'mdi-eye'"
                                                clearable                                               
                                            ></v-text-field> 

                                            
                                            <v-text-field
                                                label="New Password"
                                                density="compact"
                                                single-line
                                                :type="visible ? 'text' : 'password'"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="password.value.value"
                                                :error-messages="password.errorMessage.value"
                                                @click:append-inner="visible = !visible"
                                                :append-inner-icon="visible ? 'mdi-eye-off' : 'mdi-eye'"
                                                clearable                                               
                                            ></v-text-field> 

                                            <v-text-field
                                                :type="visible ? 'text' : 'password'"
                                                label="Re-Type Password"
                                                density="compact"
                                                single-line
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="retypepassword.value.value"
                                                :error-messages="retypepassword.errorMessage.value"
                                                @click:append-inner="visible = !visible"
                                                :append-inner-icon="visible ? 'mdi-eye-off' : 'mdi-eye'"
                                                clearable                                                
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>


                                    <v-divider></v-divider>
                                    <v-card-actions>
                                        <v-layout class="justify-center">
                                            <v-btn class="bg-red me-2" type="reset">Reset</v-btn>
                                            <v-btn class="bg-brand w-15" type="submit">Update</v-btn>                                        
                                        </v-layout>
                                    </v-card-actions>
                                </v-form>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>

import breadCrumbs from '@/components/utils/breadCrumbs.vue';
import {useStore} from 'vuex';
import { useField, useForm } from 'vee-validate';
import * as yup from 'yup';
import { ref } from 'vue';
import { toast } from 'vue3-toastify';
export default {
        components: {
            breadCrumbs
        },
        data: () => ({
            panel: [0],
            loading:false,
            errorMessages:'',
            visible: false,
        }),
        methods: {
        },
        setup() {
            const { handleSubmit, resetForm} = useForm({
                validationSchema: yup.object({
                    current_password: yup.string()
                        .required('Current Password is required'),
                    password: yup.string()
                        .required('Password is required'),
                        /* .matches(
                            /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@$!%*#?&]{6,30}$/,
                            'Password must contain letters and numbers (special characters optional) and be 6 to 30 characters long'
                        ).trim().test('no-spaces', 'Spaces are not allowed', (value) => !/\s/.test(value)), */
                    retypepassword: yup.string().required('Retype Password is required').oneOf([yup.ref('password')], 'Passwords must match'),
                }),
            });
            const current_password = useField('current_password');
            const password = useField('password');
            const retypepassword = useField('retypepassword');
            const errorMessages  = ref('');
            const store = useStore();
            const submit = handleSubmit((values) => {
                store.dispatch("updateUserPassword", values)
                    .then((response) => {
                        resetForm();
                        toast.success(response.data.message);
                    })
                    .catch((error) => {            
                        toast.error(error.response.data.message);          
                    })
            });
            return {
            submit,
            errorMessages,
            current_password,
            password,
            retypepassword
            }
        },
        mounted() {
        }  
    }
</script>
